export default "__VITE_ASSET__DbpLVB0V__"